import { css } from "@emotion/react";
import { media } from "styles/breakpoints";
import { theme } from "styles/theme";

export const CategoryGameNewStyle = {
  wrapper: () => css`
    padding-top: 75px;
    min-width: 1200px;
    min-height: 850px;
  `,

  container: () => css`
    display: flex;
    justify-content: center;
    flex: 13;
    padding-top: 46px;
    width: 1200px;
    margin: 0 auto;
    gap: 12px;

    ${media.xxl} {
      width: 1000px;
    }
  `,

  contentRight: {
    index: () =>
      css`
        flex: 8;
        display: flex;
        justify-content: flex-end;
        align-items: flex;
        position: relative;
      `,
  },

  contentLeft: {
    index: () => css`
      flex: 5;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 44px 0;
    `,

    header: () => css`
      position: relative;
      display: flex;
      justify-content: flex-end;
      align-items: flex;
    `,

    info: () => css`
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      font-size: 14px;
      font-weight: 400;
      line-height: 21px;
      margin-top: 12px;
    `,

    description: (isShowMore: boolean) => css`
      color: ${theme.colors.lightText};
      margin-top: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: ${isShowMore ? "initial" : "-webkit-box"};
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    `,

    readMore: (selectedProvider: string, providerCode: string) => css`
      color: ${theme.colors.darkGreen};
      cursor: pointer;
      margin-bottom: 17px;
      z-index: ${selectedProvider === providerCode ? "99" : "0"};
    `,

    buttonEnterGame: () => css`
      margin-top: 24px;
      transition: all 0.3s ease;
      cursor: pointer;

      background: ${theme.colors.gradient[1]};
      padding: 18px 32px;
      border-radius: 32px;
      box-shadow: 0px 6px 6px -4px rgba(0, 0, 0, 0.75);
      span {
        color: white;
        font-size: 19px;
      }
      &:hover {
        transform: scale(1.05);
      }
    `,
  },
};
